import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from "vue-gtag"
import { updateSeoHead } from './seo/head'
import SeoBeginnerGuide from '@/components/seo/SeoBeginnerGuide.vue'

Vue.component('SeoBeginnerGuide', SeoBeginnerGuide)

Vue.use(VueGtag, {
  config: { 
    id: "G-L3QB1V58QP" // Replace with your Google Analytics Measurement ID
  }
}, router);

router.afterEach((to) => {
  Vue.nextTick(() => updateSeoHead(to, router))
})

const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
